
import { getReportTabUrl, getDashboardTabUrl } from 'utils/routing';

// DASHBOARD
export const dashboardTopLeadsTab = (url, isDefault = false) => (getDashboardTabUrl(isDefault, url, 'top_leads'));
export const dashboardPotentialReachTab = (url, isDefault = false) =>
  (getDashboardTabUrl(isDefault, url, 'campaign_summary'));

export const dashboardTopLeadsTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/top_leads`);
export const dashboardPotentialReachTabPath = (path, isDefault = false) =>
  (isDefault ? `${path}` : `${path}/campaign_summary`);

// ACCOUNTS
export const accountDetail = '/accounts/:id';
export const accountContacts = `${accountDetail}/contacts`;
export const accountSubscriptions = `${accountDetail}/subscriptions`;
export const accountReports = `${accountDetail}/reports`;

export const accountDetailUrl = accountId => `/accounts/${accountId}`;
export const accountContactsUrl = accountId => `${accountDetailUrl(accountId)}/contacts`;
export const accountSubscriptionsUrl = accountId => `${accountDetailUrl(accountId)}/subscriptions`;
export const accountReportsUrl = accountId => `${accountDetailUrl(accountId)}/reports`;

// CAMPAIGNS
export const campaignSequences = '/campaigns/:id';
export const campaignInbox = `${campaignSequences}/inbox`;
export const campaignInboxWithMessage = `${campaignInbox}/:messageId`;
export const campaignReports = `${campaignSequences}/reports`;

export const campaignDetailUrl = campaignId => `/campaigns/${campaignId}`;
export const campaignInboxUrl = campaignId => `${campaignDetailUrl(campaignId)}/inbox`;
export const campaignReportsUrl = campaignId => `${campaignDetailUrl(campaignId)}/reports`;

// REPORTS
export const reportManagersTab = (url, isDefault = false) => (getReportTabUrl(isDefault, url, 'managers'));
export const reportAccountsTab = (url, isDefault = false) => (getReportTabUrl(isDefault, url, 'accounts'));
export const reportCampaignsTab = (url, isDefault = false) => (getReportTabUrl(isDefault, url, 'campaigns'));
export const reportSequencesTab = (url, isDefault = false) => (getReportTabUrl(isDefault, url, 'sequences'));
export const reportTemplatesTab = (url, isDefault = false) => (getReportTabUrl(isDefault, url, 'steps'));

export const reportOpportunitiesTabPath = (path, isDefault = false) =>
  (isDefault ? `${path}` : `${path}/opportunities`);
export const reportManagersTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/managers`);
export const reportAccountsTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/accounts`);
export const reportCampaignsTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/campaigns`);
export const reportSequencesTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/sequences`);
export const reportTemplatesTabPath = (path, isDefault = false) => (isDefault ? `${path}` : `${path}/steps`);

// SEQUENCES
export const sequenceTab = '/sequences/:id';
export const sequenceStepsTab = `${sequenceTab}/steps`;
export const sequenceCustomizePitchesTab = `${sequenceTab}/customize-pitches`;

export const sequenceTabUrl = sequenceId => `/sequences/${sequenceId}`;
export const sequenceStepsTabUrl = sequenceId => `${sequenceTabUrl(sequenceId)}/steps`;
export const sequenceCustomizePitchesTabUrl = sequenceId => `${sequenceTabUrl(sequenceId)}/customize-pitches`;

// Profile Dropdown
export const HELP_CENTER = 'https://help.prvolt.com/';
export const BILLING = 'https://prvolt.chargebeeportal.com/';
export const CSV_HELP_ARTICLE =
  'https://help.prvolt.com/en/articles/5516885-common-mistakes-with-uploading-contact-file';
